import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Contact from '../components/Contact';
import { cases } from '../data/cases';
import CaseCard from '../components/CaseCard';

const AllCases = () => {
  const navigate = useNavigate();
  const { lang = 'en' } = useParams();
  const { t } = useTranslation('services');

  const caseStudies = cases;

  return (
    <section className="bg-black pt-8" data-section="all-cases">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-between items-start mb-16"
        >
          <div>
            <p className="text-white/60 text-sm font-semibold mb-2 uppercase tracking-wider flex items-center gap-2">
              <span className="w-2 h-2 bg-white/60 rounded-full"></span>
              {t('allCases.badge')}
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              {t('allCases.title')}
            </h2>
          </div>
          <div className="text-right max-w-md">
            <div
              onClick={() => navigate(`/${lang}`)}
              className="inline-block bg-black text-white border-2 border-white rounded-2xl px-4 py-2 mb-3 cursor-pointer hover:bg-white hover:text-black transition-all duration-300"
            >
              <p className="text-sm font-medium">
                {t('allCases.backToHome')}
              </p>
            </div>
            <p className="text-lg text-white/70">
              {t('allCases.description')}
            </p>
          </div>
        </motion.div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-32">
          {caseStudies.map((caseStudy, index) => (
            <CaseCard
              key={caseStudy.id}
              caseStudy={caseStudy}
              index={index}
              onClick={() => navigate(`/${lang}/cases/${caseStudy.id}`)}
              showDescription={true}
            />
          ))}
        </div>
      </div>

      {/* Contact Form Section */}
      <Contact />
    </section>
  );
};

export default AllCases;
